import { ColumnDef } from "@tanstack/react-table";
import { LineClampedTooltip } from "@volca/ui/components/ui/line-clamped-tooltip";
import { formatPhoneNumber } from "@/core/utils/phone";
import { IReferral } from "@/referrals/referral";

const CustomerNameCol = (): ColumnDef<IReferral> => ({
  header: "Customer name",
  accessorFn: (row) =>
    row.potential_customer.name ||
    formatPhoneNumber(row.potential_customer.phone_number) ||
    "–",
  size: 160,
  minSize: 160,
  cell: ({ getValue }) => (
    <LineClampedTooltip>{getValue() as string}</LineClampedTooltip>
  ),
});

export default CustomerNameCol;
